import React from 'react';
import { observer } from 'mobx-react-lite';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { toTextQuestionAnswer } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditDate } from './edit/EditDate';
import { ViewDate } from './view/ViewDate';
export const Date = observer(({
  id,
  questionStore,
  displayMode
}) => {
  // Note: 'platform.proforma-read-only-questions.wewrsr' does not exist. And this feature hasn't been rolled out
  // It is anticipated this may be picked up in the future, so leaving this here for now.
  // https://atlassian.slack.com/archives/C054HFSPTJB/p1686699001098739
  // If you are planning to use this feature flag, make sure you create a flag with the correct name or update it below.
  const showEditComponent = displayMode === DisplayMode.Edit && !(getBooleanFF('platform.proforma-read-only-questions.wewrsr') && questionStore.formQuestion.readOnly);
  if (showEditComponent) {
    return /*#__PURE__*/React.createElement(EditDate, {
      id: id,
      value: toTextQuestionAnswer(questionStore.currentAnswer),
      isInvalid: !!questionStore.validationErrors,
      onChange: value => questionStore.setAnswer(value)
    });
  }
  return /*#__PURE__*/React.createElement(ViewDate, {
    id: id,
    value: toTextQuestionAnswer(questionStore.currentAnswer),
    displayMode: displayMode
  });
});